import LabelIcon from '@material-ui/icons/Label';

import { CompaniesList } from './CompaniesList';

export const companiesResource = {
  list: CompaniesList,
  icon: LabelIcon,
};
